import { LangLink } from "./LangLink";
import { useLanguage } from "@/lib/language";

const steps = [
  {
    title: { en: "Understand the requirement", ar: "حدّد المتطلبات" },
    text: {
      en: "Tell us your activity, buyer requirements and target date.",
      ar: "أخبرنا بنشاط شركتك ومتطلبات المشتري والموعد المستهدف.",
    },
  },
  {
    title: { en: "Prepare the evidence", ar: "جهّز الوثائق" },
    text: {
      en: "Get support with management systems and supplier documents.",
      ar: "احصل على دعم في إعداد أنظمة الإدارة ووثائق الموردين.",
    },
  },
  {
    title: { en: "Confirm the route", ar: "تحقّق من المسار" },
    text: {
      en: "Confirm the issuing body and its scope. Certification and buyer approval are independent decisions.",
      ar: "تحقّق من الجهة المانحة ونطاق اعتمادها. منح الشهادة وقبول المشتري قراران مستقلان.",
    },
  },
];
export function WhyChooseUs() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#f5f3ef]" aria-labelledby="support-heading">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 sm:py-24">
        <div className="max-w-xl text-start">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary">
            {t({ en: "A clear starting point", ar: "بداية واضحة" })}
          </p>
          <h2
            id="support-heading"
            className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl"
          >
            {t({ en: "From requirements to preparation.", ar: "من تحديد المتطلبات إلى التحضير." })}
          </h2>
        </div>
        <div className="mt-12 grid gap-10 md:grid-cols-3">
          {steps.map((step, i) => (
            <div key={step.title.en} className="border-t border-border pt-6 text-start">
              <span className="text-sm text-primary" aria-hidden="true">
                0{i + 1}
              </span>
              <h3 className="mt-4 text-xl font-semibold">{t(step.title)}</h3>
              <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">
                {t(step.text)}
              </p>
            </div>
          ))}
        </div>
        <p className="mt-10 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          {t({
            en: "IraqCert provides preparation support. The certification body conducts the independent audit and makes the certification decision. Approval of supplier registration remains with the buyer.",
            ar: "تقدّم عراق سيرت دعم التحضير. تجري جهة منح الشهادات التدقيق بصورة مستقلة وتتخذ قرار منح الشهادة. وتبقى الموافقة على تسجيل المورد بيد المشتري.",
          })}
        </p>
        <LangLink
          to="/about"
          className="mt-4 inline-flex min-h-11 items-center text-sm font-semibold text-primary underline underline-offset-4"
        >
          {t({ en: "How certification is delivered", ar: "كيف تُمنح الشهادة" })}
        </LangLink>
      </div>
    </section>
  );
}
